export default __webpack_public_path__ + "static/media/HT-AS.b6da8ea2.svg";